import { IAppState } from '../../redux';
import { EGeoDetailType } from '../../redux/reducers';
import { selectUserGeoId } from '../user';

export const selectLocationsFromAddress = (state: IAppState) => {
  const userLocationPath = [ selectUserGeoId(state) ];

  const addresses = state.offer.geo?.address || [];

  const locations = addresses.filter(({ type }) => type === EGeoDetailType.location)
    .map(({ id }) => id);

  return locations.length > 0 ? locations : userLocationPath;
};
